import { createAuth0 } from '@auth0/auth0-vue';
import { createRedirectUri } from './redirect-uri';
import { getCurrentLocale } from './deviceLocale';
import { isPlatform } from '@ionic/vue';

const redirect_uri = createRedirectUri(
  process.env.VUE_APP_PACKAGE_ID,
  process.env.VUE_APP_AUTH0_DOMAIN,
);
console.log('redirect_uri: ' + redirect_uri);

const isNative = isPlatform('ios') || isPlatform('android');
console.log('isNative: ' + isNative);

const isNativeBrowser = isPlatform('mobileweb');
console.log('isNativeBrowser: ' + isNativeBrowser);

const initialLocale = await getCurrentLocale('Regional');

export const auth0 = createAuth0(
  {
    domain: process.env.VUE_APP_AUTH0_DOMAIN,
    clientId: process.env.VUE_APP_AUTH0_CLIENT_ID,
    authorizationParams: {
      redirect_uri,
      audience: process.env.VUE_APP_AUTH0_AUDIENCE,
      ui_locales: initialLocale,
    },
    cacheLocation: 'localstorage',
    useRefreshTokens: true,
  },
  {
    skipRedirectCallback: true,
  },
);
